<script>
import i18n from "../i18n";
import ChangePassword from "@/components/widgets/modal/change-password";
import { mixin } from "@/helpers/Vue-Mixin";
import { getProfile } from "../helpers/Auth";

export default {
  components: { ChangePassword },
  mixins: [mixin],
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/japan.png"),
          language: "jp",
          title: "Japan",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: "jp",
      me: getProfile(),
      change_password: false,

    };
  },

  mounted() {
    this.lan = "jp";
    this.text = "Japan";
    i18n.locale = "jp";
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },

    openModalChangePassword() {
      this.change_password = true;
    },
    logout() {
      this.confirm(
        {
          title: "",
          text: "ログアウトしますか？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: this.me.facility?.type === 1 ? "#8FC31F" : "#395299",
          cancelButtonColor: "#FF5858",
          confirmButtonText: "はい",
          cancelButtonText: "いいえ",
          confirmButtonWidth: "800px"

        },
        async (e) => {
          // eslint-disable-next-line no-console
          if (e.isConfirmed) {
            window.toastr.success("ログアウトに成功しました");
            setTimeout(() => this.$router.push("/logout"), 50);
          }
        }
      );
    },
  },
};
</script>
<style>
.swal2-styled.swal2-confirm {
  width: 120px;
}

.swal2-styled.swal2-cancel {
  width: 120px;
}
</style>

<template>
  <header id="page-topbar">
    <ChangePassword lazy @closeModal="change_password = false" :isShow="change_password"
      :theme="me.facility?.type === 1 ? 'normal' : 'plus'" />
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box" v-if="me.role.name === 'admin'">
          <p class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-kytu.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-login.svg" alt height="17" />
            </span>
          </p>

          <p class="logo logo-light ">
            <span class="logo-sm">
              <img src="@/assets/images/logo-kytu.svg" alt height="22" />
            </span>
            <span class="logo-lg pt-3">
              <img src="@/assets/images/logo-kurua.png" alt height="30" style="margin-top: 30px;" />
            </span>
          </p>
        </div>
        <button id="toggle" type="button" class="btn btn-sm me-2 font-size-16 border-0"
          style="font-family: 'Font Awesome 5 Free' !important;" @click="toggleMenu" v-if="me.role.name === 'admin'">
          <i class="fa fa-fw fa-bars" style="font-family: 'Font Awesome 5 Free' !important;"></i>
        </button>
      </div>

      <span id="title" class="font-size-20"
        :style="{ fontWeight: '700', marginLeft: me.facility?.type === 1 ? '80px' : '50px',color: me.role.name === 'admin' ? '#007E41 !important' : ''  }">
        {{
          me.role.name === 'admin'
            ? 'くるあシリーズ　ワークステーション　管理者用'
            : me.facility?.type === 1
              ? 'くるあ　ワークステーション'
              : 'くるあプラス　ワークステーション'
        }}
      </span>


      <div class="d-flex align-items-center">
        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <span class="ms-1 font-weight-semibold">
              {{ me && me.information ? me.information.fullname : "Null----" }}
            </span>
            <i class="mdi mdi-chevron-down d-xl-inline-block"></i>
          </template>
          <b-dropdown-item class="d-block" href="javascript: void(0);" @click="openModalChangePassword()">
            <img src="@/assets/images/key-pass.svg" />
            {{ $t("navbar.dropdown.henry.list.change_password") }}
          </b-dropdown-item>
          <hr />
          <a href="javascript: void(0)" @click="logout()" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            {{ $t("navbar.dropdown.henry.list.logout") }}
          </a>
        </b-dropdown>
      </div>

    </div>
  </header>
</template>
